import React from "react";
import client from "@culturehq/client";
import { Form, Icon, Modal, NumberField, PlainButton, SubmitButton, Success, TextField } from "@culturehq/components";

import { useTryCatch } from "app/hooks";
import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModal from "components/common/ChqModal";
import getUserName from "app/utils/getUserName";

const IncrementUserPoints = ({ user }) => {
  const [{ error, success }, onSubmit] = useTryCatch(
    values => {
      const points = values.points ? Number(values.points) : 0;
      return client.incrementUserPoints({ points, userId: user.id, detail: values.detail });
    },
    [user]
  );

  return (
    <ChqModal
      trigger={onTrigger => (
        <PlainButton onClick={onTrigger}>
          <Icon icon="trophy" />
          <Trans>Give {getUserName(user)} a community score bonus</Trans>
        </PlainButton>
      )}
      entrance="zoomIn"
      width="narrow"
    >
      <Modal.Heading>
        <Trans>Community Score Bonus for {getUserName(user)}</Trans>
      </Modal.Heading>
      <Modal.Body>
        {error && <ErrorMessage error={error} />}
        {success && <Success>Success!</Success>}

        {!success && (
          <Form onSubmit={onSubmit}>
            <NumberField name="points" required>
              <Trans>Community Score</Trans>
            </NumberField>
            <TextField name="detail">
              <Trans>Reason for Bonus</Trans>
            </TextField>
            <SubmitButton primary fillParent>
              {submitting => (
                submitting
                  ? t("Submitting...")
                  : t("Award Bonus")
              )}
            </SubmitButton>
          </Form>
        )}
      </Modal.Body>
    </ChqModal>
  );
};

export default IncrementUserPoints;
